import React, { useEffect, useState, useRef } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import axiosInstance from "../Axios/AxiosInstance";
import ReusableTable from "../Components/Table/ReusableTable";
import { MdFilterAltOff } from "react-icons/md";
import DatePicker from "../Components/DatePicker/DatePicker";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BsCalendar3 } from "react-icons/bs";

const SchemeMaterialFile = () => {
    const [scannedQrData, setscannedQrData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(8);
    const [selectedRows, setSelectedRows] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [selectedDates, setSelectedDates] = useState({ startDate: '', endDate: '' });

    const pageDataRef = useRef({});
    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowDatePicker(false)
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // const getCurrentDate = () => {
    //     const date = new Date();
    //     const day = String(date.getDate()).padStart(2, '0');
    //     const month = String(date.getMonth() + 1).padStart(2, '0');
    //     const year = date.getFullYear();
    //     return `${year}-${month}-${day}`;
    // };

    const formatDate = (date) => {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [year, month, day].join('-');
    };

    const formatDateDisplay = (date) => {
        const [year, month, day] = date.split('-');
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        fetchSchemeFileData();
    }, [currentPage, rowsPerPage, searchInput, selectedDates]);


    const fetchSchemeFileData = () => {
        const cacheKey = `${currentPage}-${rowsPerPage}-${selectedDates.startDate || ""}-${selectedDates.endDate || ""}-${searchInput}`;

        const formatDate = (isoDateString) => {
            if (!isoDateString) return '';
            const [year, month, day] = isoDateString.substring(0, 10).split("-");
            return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
        };

        if (pageDataRef.current[cacheKey]) {
            setscannedQrData(pageDataRef.current[cacheKey]);
            setIsLoading(false);
        } else {
            setIsLoading(true);

            axiosInstance
                .post("/schemes/GetAllSchemesFiles", {
                    fromDate: selectedDates.startDate,
                    toDate: selectedDates.endDate,
                    SchemeFileType:"MaterialFile",
                    dealerId: 0,
                    painterId: 0,
                    pageNumber: currentPage,
                    pageSize: rowsPerPage,
                    searchItem: searchInput || "",
                })
                .then((response) => {
                    const { schemeFilesData, paginatedData } = response.data;

                    const updatedscannedQrCodeList = schemeFilesData.map((order) => ({
                        ...order,
                        createdAt: formatDate(order.createdAt),
                    }));

                    setscannedQrData(updatedscannedQrCodeList);
                    setTotalRecords(paginatedData.totalRecords);
                    // pageDataRef.current[cacheKey] = updatedscannedQrCodeList;
                    setIsLoading(false);
                })
                .catch((error) => {
                    setIsLoading(false);
                    console.error("Error fetching order data:", error);
                });
        }
    };


    const clearFilters = () => {
        setSelectedDates({ startDate: '', endDate: '' });
        setSearchInput('');
    };

    const columns = [
        { key: "schemesName", label: "Scheme Name" },
        { key: "uploadFileName", label: "File Name" },
        { key: "createdAt", label: "Uploaded Date" },
        { key: "createdBy", label: "Uploaded By" },
        { key: "isActive", label: "Status" },
    ];

    const handleSelectedRowsChange = (newSelectedRows) => {
        setSelectedRows(newSelectedRows);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleRowsPerPageChange = (event) => {
        const newRowsPerPage = Number(event.target.value);
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(1);
    };

    const handleSearchInputChange = (e) => {
        const newSearchValue = e.target.value;
        setSearchInput(newSearchValue);
        setCurrentPage(1);
    };

    const handleDateSubmit = (dates) => {
        const formattedDates = {
            startDate: formatDate(dates.startDate),
            endDate: formatDate(dates.endDate),
        };
        setSelectedDates(formattedDates);
        setShowDatePicker(false);
    };

    const handleDownloadClick = (row) => {
        const { id } = row;

        axiosInstance
            .get("/schemes/SchemeFileDownload", {
                params: { fileId: id },
            })
            .then((response) => {
                const { fileName, fileType, fileData } = response.data;

                if (fileName && fileType && fileData) {
                    const byteCharacters = atob(fileData);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: "application/vnd.ms-excel" });

                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", `${fileName}${fileType}`);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    toast.error("File data is missing in the response.");
                }
            })
            .catch((error) => {
                console.error("Error downloading file:", error);
                toast.error("Failed to download file. Please try again.");
            });
    };

    return (
        <div className="flex flex-col min-h-screen">
            <Header title={"Material Files"} />
            <div className="flex flex-col flex-1 mx-2 my-2">

                <div className="flex flex-wrap justify-between items-center mt-2 mb-1">
                    <div className="flex items-center gap-4 ml-1">
                        <input
                            type="text"
                            placeholder="Search by Scheme Name"
                            className="px-4 py-2 border border-gray-300 rounded-lg w-[300px] focus:outline-none focus:ring-2 focus:ring-black-500"
                            value={searchInput}
                            onChange={handleSearchInputChange}
                        />
                        {selectedDates.startDate && (
                            <div className="ml-2 flex space-x-3">
                                <span className="bg-[#1e365e] text-white px-3 py-2 rounded-lg shadow-md">
                                    From: {formatDateDisplay(selectedDates.startDate)}
                                </span>
                                <span className="bg-[#1e365e] text-white px-4 py-2 rounded-lg shadow-md ">
                                    To: {formatDateDisplay(selectedDates.endDate)}
                                </span>
                            </div>
                        )}
                    </div>
                    <div className="flex items-center gap-3 mr-5">
                        <span
                            className="text-[#1e365e] cursor-pointer hover:text-[#1e365e]  "
                            onClick={clearFilters}
                            title="Clear Filter"
                        >
                            <MdFilterAltOff size={32} />
                        </span>
                        <span
                            className="text-[#1e365e] cursor-pointer hover:text-[#1e365e]  "
                            onClick={() => setShowDatePicker(!showDatePicker)}
                            title="Date Filter"
                        >
                            <BsCalendar3 size={25} />
                        </span>
                        {/* <span
                            className="text-[#1e365e] cursor-pointer hover:text-[#1e365e]  "
                            onClick={handleDownload}
                            title="Download"
                        >
                            <MdDownload size={32} />
                        </span> */}
                    </div>
                </div>
                <div className="mt-2 p-1">
                    <ReusableTable
                        data={scannedQrData}
                        columns={columns}
                        rowsPerPage={rowsPerPage}
                        loading={isLoading}
                        currentPage={currentPage}
                        totalRecords={totalRecords}
                        enableDownload={true}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleRowsPerPageChange}
                        onSelectedRowsChange={handleSelectedRowsChange}
                        onDownloadClick={handleDownloadClick}
                    />
                </div>
                {showDatePicker && (
                    <dialog open
                        style={{
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            border: "none",
                            background: "none",
                            maxHeight: "70vh",
                            overflowY: "auto",
                        }}
                        ref={popupRef}>
                        <div >
                            <DatePicker onCancel={() => setShowDatePicker(false)} onSubmit={handleDateSubmit} />
                        </div>
                    </dialog>
                )}
            </div>
            <Footer />
            <ToastContainer />
        </div>
    );
};

export default SchemeMaterialFile;
